var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7C4DFF",
    d: "M4.5 4.5v11h11V11H17v6H3V3h5v1.5H4.5ZM11.004 2.986H17V4.49h-5.996V2.986Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C4DFF",
    d: "M15.496 9.004V3H17v6.004h-1.504Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#7C4DFF",
    d: "m9.473 9.45 6.465-6.464L17 4.049l-6.465 6.465z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewTab);
export default __webpack_public_path__ + "static/media/new_tab.3be5c4641cfea112bb0048270eeffacf.svg";
export { ForwardRef as ReactComponent };